import http from "../utils/http"

/**
 * 獲取批發專區列表
 */
 export function wholesalePage(params) {
  return http({
      url: "/wholesale/api/goods/page",
      data: params
  })
}
/**
 * 獲取批發專區列表
 */
 export function wholesaleDetail(params) {
  return http({
      url: "/wholesale/api/goods/detail",
      data: params
  })
}

/**
 * 獲取進貨單否購物車列表
 */
 export function wholesaleCartList(params) {
  return http({
      url: "/wholesale/api/cart/lists",
      data: params
  })
}
/**
 * 獲取進貨單數量
 */
 export function getCartCount(params) {
  return http({
      url: "/wholesale/api/cart/count",
      data: params
  })
}
/**
 * 刪除進貨單
 * @param {array} params
 */
 export function deleteCart(params) {
  return http({
      data: params,
      url: "/wholesale/api/cart/delete",
      forceLogin: true
  })
}

/**
 * 修改進貨單數量
 * @param {array} params
 */
 export function editCartNum(params) {
  return http({
      data: params,
      url: "/wholesale/api/cart/edit",
      forceLogin: true
  })
}
/**
 * 加入進貨單
 * @param {array} params
 */
 export function addToCart(params) {
  return http({
      data: params,
      url: "/wholesale/api/cart/add",
      forceLogin: true
  })
}